import { withStyles } from '@material-ui/core'
import { ToggleButtonGroup } from '@material-ui/lab'
import { GRAY_COLORS } from 'asterX-UI/colors.constant'

export const AsterToggleButtonGroup = withStyles(theme => ({
  root: {
    padding: 4,
    border: `1px solid ${GRAY_COLORS[200]}`,
    borderRadius: 8,
    gap: 4
  }
}))(ToggleButtonGroup)
